// extracted by mini-css-extract-plugin
export default {"read_more_container":"styles_read_more_container__n+Igb","readmore":"styles_readmore__nbBu4"};